import { Component } from '@angular/core';

@Component({

  selector: 'notfound',  // <home></home>
  providers: [  ],
  styles: [ require('./no-content.component.css') ],
  template: require('./no-content.component.html')
})
export class NoContentComponent {

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/no-content/no-content.component.ts